import { useCurrentVerticalData } from './use-current-vertical-data.hook';
import { GtmService } from '../services/gtm.service';
import {
    GtmEventLocation,
    GtmEventComponent,
    GtmEventClickElement
} from '../components/google-tag-manager/enums/gtm-event-enum';

export const useTrackOpenGameGtm = () => {
    const {
        pamGameVerticalID,
        currentVerticalType
    } = useCurrentVerticalData();

    return (gameId, options = {}) => {
        const {
            location = GtmEventLocation.GAME_GRID,
            component = GtmEventComponent.GAMES_THUMBNAIL,
            clickElement = GtmEventClickElement.BUTTON,
            clickAction = 'open game',
        } = options;

        GtmService.track({
            location,
            component,
            click_element: clickElement,
            click_action: clickAction,
            game_id: gameId,
            game_vertical_id: pamGameVerticalID,
            game_vertical_type: currentVerticalType,
        });
    };
};
